<template>
    <div class="layout">
        <aside class="sidebar" :class="{ collapsed: isCollapsed }">
            <ul>
                <li @click="toggleMenu">
                    <img :src="menuIcon" alt="Toggle Menu" />
                    <span>{{ isCollapsed ? 'Expandir' : 'Recolher' }}</span>
                </li>


                <li @mouseover="showCadastrosMenu = true" @mouseleave="showCadastrosMenu = false">
                    <img src="@/assets/icons/menuCadastros.svg" />
                    <span>Cadastros</span>
                    <div v-if="showCadastrosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('AtividadesTabPage', 'LISTA DE ATIVIDADES')">
                                <span>Atividades</span>
                            </li>
                            <li @click="selectOption('ContasEmailTabPage', 'CONTAS DE EMAIL')">
                                <span>Contas de Email</span>
                            </li>
                            <li @click="selectOption('FeriadosTabPage', 'FERIADOS')">
                                <span>Feriados</span>
                            </li>
                            <li @click="selectOption('MunicipiosTabPage', 'MUNICÍPIOS')">
                                <span>Municípios</span>
                            </li>
                            <li @click="selectOption('EpEditPage', 'ASSOCIAÇÃO/MUNICÍPIO')">
                                <span>Instituição</span>
                            </li>
                            <li @click="selectOption('ProdutosTabPage', 'TABELA DE PRODUTOS')">
                                <span>Produtos</span>
                            </li>
                            <li @click="selectOption('ProdutosMapaTabPage', 'PRODUTOS MAPA - ESPECÍFICOS')">
                                <span>Produtos Mapa Específicos</span>
                            </li>
                            <li @click="selectOption('EpRdTabPage', 'RISCO DE DESEMPENHO')">
                                <span>Risco de Desempenho</span>
                            </li>
                            <li @click="selectOption('SimInspetorEditPage', 'SIM x INSPETORES')">
                                <span>SIM x Inspetores</span>
                            </li>
                            <li @click="selectOption('TpDocsTabPage', 'TIPOS DE DOCUMENTOS')">
                                <span>Tipos de Documentos</span>
                            </li>
                            <li @click="selectOption('TpProducaoTabPage', 'TABELA TIPOS PRODUÇÃO')">
                                <span>Tipos de Produção</span>
                            </li>
                            <li @click="selectOption('UsuariosAdminTabPage', 'ADMINISTRADORES ESTABELECIMENTOS')">
                                <span>Usuários Administradores</span>
                            </li>
                            <li @click="selectOption('UsuariosSupervisoresTabPage', 'SUPERVISORES')">
                                <span>Usuários Supervisores</span>
                            </li>
                            <li @click="selectOption('UsuariosGestoresTabPage', 'GESTORES')">
                                <span>Usuários Gestores</span>
                            </li>
                            <li @click="selectOption('UsuariosInspetoresTabPage', 'INSPETORES')">
                                <span>Usuários Inspetores</span>
                            </li>
                            <li @click="selectOption('UsuariosRtTabPage', 'RESPONSÁVEIS TÉCNICOS')">
                                <span>Usuários RTs</span>
                            </li>
                        </ul>
                    </div>
                </li>
                
                <li @click="setComponenteAtivo('SimsSupervisorTabPage', 'SERVIÇOS DE INSPEÇÃO')">
                    <img src="@/assets/icons/menuSims.png" />
                    <span>Serviços de Inspeção</span>
                </li>

                <li @click="setComponenteAtivo('EstabelecimentosInspetorTabPage', 'ESTABELECIMENTOS')">
                    <img src="@/assets/icons/menuEstabelecimentos.png" />
                    <span>Estabelecimentos</span>
                </li>

                <li @click="setComponenteAtivo('ListaAtividadesPage', 'HISTÓRICO DE ATIVIDADES')">
                    <img src="@/assets/icons/menuHistory.png" />
                    <span>Histórico de Atividades</span>
                </li>

                <li @click="setComponenteAtivo('Pla08TabPage', 'AÇÕES CORRETIVAS')">
                    <img src="@/assets/icons/menuRAC.png" />
                    <span>Ações Corretivas (RAC)</span>
                </li>

                <li @click="setComponenteAtivo('AnexosSupervisorListaPage', 'DOCUMENTAÇÕES DE ESTABELECIMENTOS')">
                    <img src="@/assets/icons/menuDocumentos.png" />
                    <span>Documentos Estabelecimentos</span>
                </li>
                
                <li @mouseover="showPlanilhasMenu = true" @mouseleave="showPlanilhasMenu = false">
                    <img src="@/assets/icons/menuTable.svg" />
                    <span>Planilhas</span>
                    <div v-if="showPlanilhasMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('PlaExpedicaoTabPage', 'PLANILHAS DE EXPEDIÇÃO')">
                                <span>Expedição</span>
                            </li>
                            <li @click="selectOption('PlaLeiteTabPage', 'PLANILHAS DE LEITE')">
                                <span>Leite</span>
                            </li>
                            <li @click="selectOption('PlaMelTabPage', 'PLANILHAS DE MEL')">
                                <span>Mel</span>
                            </li>
                            <li @click="selectOption('PlaMpTabPage', 'PLANILHAS DE MATÉRIA PRIMA')">
                                <span>Matéria Prima</span>
                            </li>
                            <li @click="selectOption('PlaProducaoTabPage', 'PLANILHAS DE PRODUÇÃO')">
                                <span>Produção</span>
                            </li>
                        </ul>
                    </div>
                </li>


                <li @mouseover="showRelatoriosMenu = true" @mouseleave="showRelatoriosMenu = false">
                    <img src="@/assets/icons/menuPrinter.png" />
                    <span>Relatórios</span>
                    <div v-if="showRelatoriosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul><li @click="selectOption('ColetaNCAnaliticoReportPage', 'RELATÓRIO: NÃO CONFORMIDADES DE COLETAS')">
                            <span>Coletas - Não Conformidades</span>
                        </li></ul>
                        
                        <ul><li @click="selectOption('EstabelecimentosReportPage', 'RELATÓRIO: ESTABELECIMENTOS')">
                            <span>Estabelecimentos</span>
                        </li></ul>
                        
                        <ul><li @click="selectOption('CapacidadeProducaoReportPage', 'RELATÓRIO: CAPACIDADE DE PRODUÇÃO')">
                            <span>Estabelecimentos - Capacidade de Produção</span>
                        </li></ul>

                        <ul><li @click="selectOption('EstebelecimentosParecerReportPage', 'RELATÓRIO: PARECER ESTABELECIMENTOS')">
                            <span>Estabelecimentos - Parecer Analítico</span>
                        </li></ul>

                        <ul><li @click="selectOption('MapaEstatisticoReportPage', 'RELATÓRIO: MAPA ESTATÍSTICO')">
                            <span>Mapa Estatístico</span>
                        </li></ul>

                        <ul><li @click="selectOption('NCAnaliticoReportPage', 'RELATÓRIO: ANALÍTICO DE NÃO CONFORMIDADES')">
                            <span>Não Conformidades - Analítico</span>
                        </li></ul>

                        <ul><li @click="selectOption('RastreabilidadeReportPage', 'RELATÓRIO: RASTREABILIDADE')">
                            <span>Rastreabilidade</span>
                        </li></ul>
                    </div>
                </li>


                <li @mouseover="showUtilitariosMenu = true" @mouseleave="showUtilitariosMenu = false">
                    <img src="@/assets/icons/menuSettings.svg" />
                    <span>Utilitários</span>
                    <div v-if="showUtilitariosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul><li @click="selectOption('DriveGrupoTabPage', 'GRUPOS')">
                            <span>Grupos (Drive)</span>
                        </li></ul>
                        <ul><li @click="selectOption('DrivePastaTabPage', 'DRIVE INTERNO')">
                            <span>Drive Interno</span>
                        </li></ul>
                        <ul><li @click="selectOption('DrivePastaTabPage-Publico', 'DRIVE PÚBLICO')">
                            <span>Drive Público</span>
                        </li></ul>
                    </div>
                </li>


                <li @click="setComponenteAtivo('MapaEnderecosPage', 'MAPA')">
                    <img src="@/assets/icons/menuMap.svg" />
                    <span>Mapa Endereços</span>
                </li>

                
                <li @click="setComponenteAtivo('UsuarioViewPage', 'USUÁRIO')">
                    <img src="@/assets/icons/menuEditUser.png" />
                    <span>Usuário</span>
                </li>


                <li class="logout" @click="confirmLogout">
                    <img src="@/assets/icons/menuLogout.svg" />
                    <span>Desconectar</span>
                </li>
            </ul>
        </aside>

        <main class="content">
            <header class="header">
                <div class="header-title">{{ nmTitulo ? nmTitulo : 'SUPERVISOR' }}</div>
                <div style="align-items: center; display: flex;">
                    <div class="user-info">
                        <div class="user-name">{{ globalStore.nmusuario }}</div>
                        <div class="establishment-name">{{ globalStore.nmep }}</div>
                    </div>
                    <div class="token-info">{{ timeRemaining }}</div>
                </div>
            </header>
            <div class="main-content">
                <slot>
                    <div v-if="nmComponenteAtivo=='AnexosSupervisorListaPage'"><AnexosSupervisorListaPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='DriveGrupoTabPage'"><DriveGrupoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='DrivePastaTabPage'"><DrivePastaTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='DrivePastaTabPage-Publico'"><DrivePastaTabPage :ckPublica="'S'" @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EstabelecimentosInspetorTabPage'"><EstabelecimentosInspetorTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ListaAtividadesPage'"><ListaAtividadesPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='Pla08TabPage'"><Pla08TabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuarioViewPage'"><UsuarioViewPage :idView=globalStore.idusuario @close="setComponenteAtivo(null, null)"/></div>

                    <div v-else-if="nmComponenteAtivo=='AtividadesTabPage'"><AtividadesTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ContasEmailTabPage'"><ContasEmailTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EpEditPage'"><EpEditPage :idEdicao="globalStore.idep" @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EpRdTabPage'"><EpRdTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='FeriadosTabPage'"><FeriadosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='MapaEnderecosPage'"><MapaEnderecosPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='MunicipiosTabPage'"><MunicipiosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ProdutosTabPage'"><ProdutosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ProdutosMapaTabPage'"><ProdutosMapaTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='SimInspetorEditPage'"><SimInspetorEditPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='SimsSupervisorTabPage'"><SimsSupervisorTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='TpDocsTabPage'"><TpDocsTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='TpProducaoTabPage'"><TpProducaoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosAdminTabPage'"><UsuariosAdminTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosInspetoresTabPage'"><UsuariosInspetoresTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosRtTabPage'"><UsuariosRtTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosSupervisoresTabPage'"><UsuariosSupervisoresTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosGestoresTabPage'"><UsuariosGestoresTabPage @close="setComponenteAtivo(null, null)"/></div>
                    
                    <div v-else-if="nmComponenteAtivo=='PlaExpedicaoTabPage'"><PlaExpedicaoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaLeiteTabPage'"><PlaLeiteTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaMelTabPage'"><PlaMelTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaMpTabPage'"><PlaMpTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaProducaoTabPage'"><PlaProducaoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    
                    <div v-else-if="nmComponenteAtivo=='CapacidadeProducaoReportPage'"><CapacidadeProducaoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='ColetaNCAnaliticoReportPage'"><ColetaNCAnaliticoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EstebelecimentosParecerReportPage'"><EstebelecimentosParecerReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EstabelecimentosReportPage'"><EstabelecimentosReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='MapaEstatisticoReportPage'"><MapaEstatisticoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='NCAnaliticoReportPage'"><NCAnaliticoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='RastreabilidadeReportPage'"><RastreabilidadeReportPage @close="setComponenteAtivo(null, null)"/></div>

                    <div v-else><ResumoGeralPage /></div>
                </slot>
            </div>
        </main>
    </div>
</template>

<script setup>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { jwtDecode } from 'jwt-decode';
import { globalStore } from '@/globals';
import { useRouter } from 'vue-router';


import AnexosSupervisorListaPage from '@/views/listas/AnexosSupervisorListaPage.vue';
import EstabelecimentosInspetorTabPage from '@/views/cadastros/tabelas/EstabelecimentosInspetorTabPage.vue';
import ListaAtividadesPage from '@/views/planilhas/tabelas/ListaAtividadesPage.vue';
import Pla08TabPage from '../../views/planilhas/tabelas/Pla08TabPage.vue';
import UsuarioViewPage from '@/views/cadastros/visualizacoes/UsuarioViewPage.vue';

// SUBMENU CADASTROS
import AtividadesTabPage from '@/views/cadastros/tabelas/AtividadesTabPage.vue';
import ContasEmailTabPage from '@/views/cadastros/tabelas/ContasEmailTabPage.vue';
import EpEditPage from '@/views/cadastros/formularios/EpEditPage.vue'
import EpRdTabPage from '@/views/cadastros/tabelas/EpRdTabPage.vue';
import FeriadosTabPage from '@/views/cadastros/tabelas/FeriadosTabPage.vue';
import MapaEnderecosPage from '@/views/dashboard/MapaEnderecosPage.vue';
import MunicipiosTabPage from '@/views/cadastros/tabelas/MunicipiosTabPage.vue';
import ProdutosTabPage from '@/views/cadastros/tabelas/ProdutosTabPage.vue';
import ProdutosMapaTabPage from '@/views/cadastros/tabelas/ProdutosMapaTabPage.vue';
import ResumoGeralPage from '../dashboards/ResumoGeralPage.vue';
import SimInspetorEditPage from '@/views/cadastros/associacoes/SimInspetorEditPage.vue';
import SimsSupervisorTabPage from '@/views/cadastros/tabelas/SimsSupervisorTabPage.vue';
import TpDocsTabPage from '@/views/cadastros/tabelas/TpDocsTabPage.vue';
import TpProducaoTabPage from '@/views/cadastros/tabelas/TpProducaoTabPage.vue';
import UsuariosAdminTabPage from '@/views/cadastros/tabelas/UsuariosAdminTabPage.vue';
import UsuariosInspetoresTabPage from '@/views/cadastros/tabelas/UsuariosInspetoresTabPage.vue';
import UsuariosRtTabPage from '@/views/cadastros/tabelas/UsuariosRtTabPage.vue';
import UsuariosSupervisoresTabPage from '@/views/cadastros/tabelas/UsuariosSupervisoresTabPage.vue';
import UsuariosGestoresTabPage from '@/views/cadastros/tabelas/UsuariosGestoresTabPage.vue';

// SUBMENU PLANILHAS
import PlaExpedicaoTabPage from '@/views/planilhas/tabelas/PlaExpedicaoTabPage.vue';
import PlaLeiteTabPage from '@/views/planilhas/tabelas/PlaLeiteTabPage.vue';
import PlaMelTabPage from '@/views/planilhas/tabelas/PlaMelTabPage.vue';
import PlaMpTabPage from '@/views/planilhas/tabelas/PlaMpTabPage.vue';
import PlaProducaoTabPage from '@/views/planilhas/tabelas/PlaProducaoTabPage.vue';

// SUBMENU RELATÓRIOS
import CapacidadeProducaoReportPage from '@/views/reports/CapacidadeProducaoReportPage.vue';
import ColetaNCAnaliticoReportPage from '../reports/ColetaNCAnaliticoReportPage.vue';
import EstebelecimentosParecerReportPage from '../reports/EstebelecimentosParecerReportPage.vue';
import EstabelecimentosReportPage from '@/views/reports/EstabelecimentosReportPage.vue';
import MapaEstatisticoReportPage from '../reports/MapaEstatisticoReportPage.vue';
import NCAnaliticoReportPage from '../reports/NCAnaliticoReportPage.vue';
import RastreabilidadeReportPage from '@/views/reports/RastreabilidadeReportPage.vue';

// SUBMENU UTILITÁRIOS
import DriveGrupoTabPage from '@/views/utils/drive/DriveGrupoTabPage.vue';
import DrivePastaTabPage from '@/views/utils/drive/DrivePastaTabPage.vue';

const isCollapsed = ref(true);
const nmComponenteAtivo = ref(null);
const nmTitulo = ref(null);
const router = useRouter();
const showCadastrosMenu = ref(false);
const showPlanilhasMenu = ref(false);
const showRelatoriosMenu = ref(false);
const showUtilitariosMenu = ref(false);

const timeRemaining = ref(null);
let timer = null;

const menuIcon = computed(() =>
  isCollapsed.value
    ? require('@/assets/icons/menuExpand.svg')
    : require('@/assets/icons/menuCollapse.svg')
);

const confirmLogout = () => {resetLogin();}

const resetLogin = () => {
    Api.loginAPI();
    router.push('/login');
}

const toggleMenu = () => { isCollapsed.value = !isCollapsed.value; }

const selectOption = (page, titulo) => {
    nmComponenteAtivo.value = page;
    nmTitulo.value = titulo;
    showCadastrosMenu.value = false;
    showPlanilhasMenu.value = false;
    showRelatoriosMenu.value = false;
    showUtilitariosMenu.value = false;
}

const setComponenteAtivo = (nome, titulo) => {
    nmComponenteAtivo.value = nome;
    nmTitulo.value = titulo;
}

const updateTimeRemaining = () => {
    const token = localStorage.getItem('jwtToken');
    if (token){
        try{
            const decodedToken = jwtDecode(token);
            const expiration = decodedToken.exp * 1000;
            const now = Date.now();
            const difference = expiration - now;

            if (difference > 0){
                const hours         = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes       = Math.floor((difference / (1000 * 60)) % 60);
                const seconds       = Math.floor((difference / 1000) % 60);
                const formattedTime = [
                    hours.toString().padStart(2, '0'),
                    minutes.toString().padStart(2, '0'),
                    seconds.toString().padStart(2, '0')
                ].join(':');
                timeRemaining.value = formattedTime;
            }else{
                timeRemaining.value = "Token expirado";
                clearInterval(timer);
                // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
            }
        }catch(error){
            console.error('Erro ao decodificar o token:', error);
            timeRemaining.value = "Erro ao verificar o token";
            clearInterval(timer);
        }
    } else {
        timeRemaining.value = "Token não encontrado";
        clearInterval(timer);
        // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
    }
};

onMounted(() => {
    updateTimeRemaining();
    timer = setInterval(updateTimeRemaining, 1000);
});

onBeforeUnmount(() => {
    clearInterval(timer);
});
</script>